import {
  PaymentCard,
  PaymentCardStatus,
  PaymentMethodCapability
} from "@wingspanhq/wingspan-api-sdk";

export const selectorPaymentCardPayoutReady = (paymentCard: PaymentCard) => {
  if (paymentCard.status !== PaymentCardStatus.ACTIVE) {
    return false;
  }

  // v1 filtered the list server-side by card type (Debit); v3 has no card type,
  // it declares the directions the instrument supports instead. `capabilities`
  // is read-only and may be absent, in which case treat it as unknown rather
  // than hiding the card.
  if (
    paymentCard.capabilities &&
    !paymentCard.capabilities.includes(PaymentMethodCapability.PAYOUT)
  ) {
    return false;
  }

  if (isDiscoverCard(paymentCard)) {
    return false;
  }

  return true;
};

function isDiscoverCard(paymentCard: PaymentCard) {
  // `brand` is optional on v3 cards; an unknown brand is not a known-bad one,
  // so treat it the same way as `capabilities` above and keep the card.
  return paymentCard.brand?.toLowerCase() === "discover";
}
